import { isEmpty, isFunction } from 'lodash'
import qs from 'query-string'
import {
  StorageManager,
  logger
} from '../../index'

/*
  Valid location with tags should be like

  localhost/?cmd=signup&utm_source=news4&utm_medium=email&utm_campaign=spring-summer
*/
const UTM_TAG_RX = /^utm_\w+$/m

class AnalyticsManager {
  constructor () {
    this.__analytics = {}
  }

  /*
    Method for storing string tag by key
  */
  setTag (key, tag) {
    this.__analytics[key] = tag
  }

  __resolveDefaultAnalytics () {
    const {
      search
    } = window.location

    const params = qs.parse(search)

    try {
      const utmKeys = Object.keys(params).filter(key => UTM_TAG_RX.test(key))

      if (!isEmpty(utmKeys)) {
        const utmOptions = utmKeys.reduce(
          (acc, key) => {
            return {
              ...acc,
              [key]: params[key]
            }
          },
          {}
        )

        this.setTag('utmMarkings', window.btoa(JSON.stringify(utmOptions)))
      }
    } catch (error) {
      logger.debug('[utm]', 'unable to parse utm tags', search)
    }

    // Any provided btag will override prev one
    if (params.btag) {
      StorageManager.setItem('btag', params.btag)
      this.setTag('btag', params.btag)
    } else {
      // Resolving prev btag
      StorageManager.getItem('btag')
        .then(btag =>
          btag && this.setTag('btag', btag)
        )
    }
  }

  /*
    Resolving and storing analytics (fingerprint, utm, btags) data
  */
  init (plugins) {
    try {
      this.__resolveDefaultAnalytics()
    } catch (error) {
      logger.warn(
        '[analytics]',
        'unable to resolve default analytics',
        error.messsage
      )
    }

    for (const tagKey of Object.keys(plugins)) {
      const resolvePluginTag = plugins[tagKey]
      if (isFunction(resolvePluginTag)) {
        try {
          resolvePluginTag().then(tag =>
            tag && this.setTag(tagKey, tag)
          )
        } catch (error) {
          logger.warn(
            '[analytics]',
            `unable to resolve ${tagKey} analytics`,
            error.messsage
          )
        }
      }
      // currenty not handling
      // typeof resolvePluginTag === 'string'
    }
  }

  /*
    Return parsed fingerprint and utm tags data
  */
  getAnalytics () {
    return this.__analytics
  }
}

const $analytics = new AnalyticsManager()
export default $analytics
